// IE 2026 10 10 / ODOO-341407 (Andrey via core #74338: sort chips in the layout list)
// Сортировка строки раскладки DL2 (dataItem.ORDER: [{use, binding, direction, sequence}]) — чипсами в колонке Fields грида раскладки, после чипсов полей.
// Чистая логика без DOM и Vue (юнит — tests/unit/dl2SortChips.test.mjs); отрисовка — AttrGrid.dl2Sort_appendChips. Выключатель fe.dl2.sortChips (по умолчанию ВКЛ).

export const FLAG_DL2_SORT_CHIPS = 'fe.dl2.sortChips'

function bindingOf(b) {
    if (b && typeof b === 'object') b = b.value
    return (typeof b === 'string') ? b.trim() : ''
}

// поле строки по binding: сначала fields, потом values (меры)
export function dl2_sortField(dataItem, binding) {
    for (const key of ['fields', 'values']) {
        const list = dataItem?.[key]
        if (!Array.isArray(list)) continue
        const f = list.find(x => x && typeof x === 'object' && bindingOf(x.binding) === binding)
        if (f) return f
    }
    return null
}

// активные записи сортировки строки: [{binding, dir: 'ASC'|'DESC', label, sequence}]; labelOf(поле | null, binding) -> показанное название
export function dl2_sortChips(dataItem, labelOf) {
    const order = dataItem?.ORDER
    if (!Array.isArray(order)) return []
    const out = []
    for (const o of order) {
        if (!o || typeof o !== 'object' || o.use === false) continue
        const binding = bindingOf(o.binding)
        if (!binding) continue
        const dir = String(o.direction || '').toUpperCase() === 'DESC' ? 'DESC' : 'ASC'
        const field = dl2_sortField(dataItem, binding)
        let label = typeof labelOf === 'function' ? labelOf(field, binding) : ''
        if (!label) label = binding
        const sequence = (o.sequence === undefined || o.sequence === null) ? '' : String(o.sequence)
        out.push({ binding, dir, label: String(label), sequence })
    }
    return out
}
